export default "/images/vendor/tinymce/skins/lightgray/loader.gif?0406bcb895265a43377d60473c4423e5";